/**
 * Keeps a bundle/coil-option radio card (sections/main-product-hero.liquid,
 * sections/product-minimax-hero.liquid) in sync with the product form's hidden variant id
 * input and any [data-buy-buttons-price] display on the page. Uses event delegation instead
 * of a custom element because the radio blocks can be interleaved with other block types by
 * the merchant, so there's no single contiguous wrapper element to hang a component on.
 */
(function () {
  function syncPriceFromRadio(radio) {
    if (!radio) return;

    var form = radio.dataset.form && document.getElementById(radio.dataset.form);
    var idInput = form && form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = radio.value;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var options = radio.closest('.vr-options');
    var panel = options && options.querySelector('.vr-panel');
    if (panel) {
      var template = options.querySelector('.vr-panel-template[data-panel-for="' + radio.value + '"]');
      if (template) {
        panel.querySelector('.vr-panel-inner').replaceChildren(template.content.cloneNode(true));
        panel.dataset.panelFor = radio.value;
        panel.classList.add('is-active');
      } else {
        panel.classList.remove('is-active');
      }
    }

    var priceEls = document.querySelectorAll('[data-buy-buttons-price]');
    priceEls.forEach(function (priceEl) {
      var nowEl = priceEl.querySelector('.now');
      if (nowEl) nowEl.textContent = radio.dataset.price || '';
      var wasEl = priceEl.querySelector('.was');
      if (radio.dataset.comparePrice) {
        if (!wasEl) {
          wasEl = document.createElement('span');
          wasEl.className = 'was';
          priceEl.appendChild(wasEl);
        }
        wasEl.textContent = radio.dataset.comparePrice;
      } else if (wasEl) {
        wasEl.remove();
      }
    });
  }

  function syncGuaranteeFromRadio(radio) {
    if (!radio) return;

    var guaranteeRoot = document.querySelector('[data-product-hero-guarantee]');
    if (!guaranteeRoot) return;

    var guaranteeText = guaranteeRoot.querySelector('[data-product-hero-guarantee-text]');
    var nextGuarantee = radio.dataset.guarantee || '';
    if (guaranteeText) guaranteeText.textContent = nextGuarantee;
    guaranteeRoot.hidden = !nextGuarantee;

    var nextIcon = radio.dataset.guaranteeIcon || 'none';
    var iconWrap = guaranteeRoot.querySelector('[data-product-hero-guarantee-icon]');
    if (iconWrap) {
      iconWrap.hidden = nextIcon === 'none';
      iconWrap.querySelectorAll('[data-guarantee-icon-option]').forEach(function (el) {
        el.hidden = el.getAttribute('data-guarantee-icon-option') !== nextIcon;
      });
    }
  }

  function syncChargeNoteFromRadio(radio) {
    if (!radio) return;

    var chargeNoteEl = document.querySelector('[data-product-hero-chargenote]');
    var paylineEl = document.querySelector('[data-product-hero-payline]');
    if (!chargeNoteEl && !paylineEl) return;

    var nextChargeNote = radio.dataset.chargeNote || '';
    if (chargeNoteEl) {
      chargeNoteEl.textContent = nextChargeNote;
      chargeNoteEl.hidden = !nextChargeNote;
    }
    if (paylineEl) {
      var payAmountEl = paylineEl.querySelector('[data-product-hero-pay]');
      if (payAmountEl && radio.dataset.payInstallment) payAmountEl.textContent = radio.dataset.payInstallment;
      paylineEl.hidden = !!nextChargeNote;
    }
  }

  function onBundleOptionChange(event) {
    var radio = event.target.closest('.vr-opt__radio');
    if (!radio) return;

    syncPriceFromRadio(radio);
    syncGuaranteeFromRadio(radio);
    syncChargeNoteFromRadio(radio);

    document.dispatchEvent(
      new CustomEvent('bundle-option:change', {
        bubbles: true,
        detail: {
          variantId: radio.value,
          formId: radio.dataset.form,
          price: radio.dataset.price,
          comparePrice: radio.dataset.comparePrice,
        },
      })
    );
  }

  function groupRadios(radio) {
    if (!radio.name) return [radio];

    return Array.prototype.filter.call(document.getElementsByName(radio.name), function (el) {
      return el.classList.contains('vr-opt__radio') && !el.disabled;
    });
  }

  function onBundleOptionKeydown(event) {
    if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;

    var radio = event.target.closest && event.target.closest('.vr-opt__radio');
    if (!radio) return;

    var radios = groupRadios(radio);
    var next = radios[radios.indexOf(radio) + (event.shiftKey ? -1 : 1)];
    if (!next) return;

    event.preventDefault();
    next.focus();
  }

  function syncCheckedRadios() {
    document.querySelectorAll('.vr-opt__radio:checked').forEach(function (radio) {
      syncPriceFromRadio(radio);
      syncGuaranteeFromRadio(radio);
      syncChargeNoteFromRadio(radio);
    });
  }

  document.addEventListener('change', onBundleOptionChange);
  document.addEventListener('keydown', onBundleOptionKeydown);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCheckedRadios);
  } else {
    syncCheckedRadios();
  }
})();
